// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"460":"aa9a9ba2","864":"8ccd9fcd"}[chunkId] + ".chunk.css";
};